import { Cell, Row, flexRender } from "@tanstack/react-table";
import classNames from "classnames";

import { useTableContext } from "../context";
import CellControl from "./edit-controls";

export default function TableRowCell<T>({
  row,
  cell,
}: {
  row: Row<T>;
  cell: Cell<T, unknown>;
}) {
  const { table, editMode, columnWidths } = useTableContext();
  const editableColumns = table?.options?.meta?.editableColumns ?? {};

  const columnId = cell.column?.id;
  const editableOptions = editableColumns[columnId] ?? undefined;
  const isEditable = !!editableOptions && editMode;
  const width = columnWidths[columnId];

  return (
    <td
      key={cell.id}
      className={classNames("py-2 px-4 truncate")}
      style={{ width }}
    >
      {isEditable ? (
        <CellControl cell={cell} row={row} options={editableOptions} />
      ) : (
        flexRender(cell.column.columnDef.cell, cell.getContext())
      )}
    </td>
  );
}
